import client from '../token_client'

export const chromeBotSignInLink = (redirectUrl, email) => {
  return client.post('chromebot/sign_in_link', {
    redirect_url: redirectUrl,
    email
  })
}
